import { Route } from '@angular/router';
import { ProjectTenantsComponent } from './tenants.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { SavedViewsResolver } from 'app/core';
import { PropertyTenantsPropertyUnitResolver, PropertyTenantsPropertyUnitsResolver } from './tenants.resolvers';
import { PropertyTenantsListComponent } from './list/list.component';
import { PropertyTenantsDetailsComponent } from './details/details.component';

export const tenantsRoutes: Route[] = [
  {
    path: '',
    component: ProjectTenantsComponent,
    resolve: {
      propertyUnits: PropertyTenantsPropertyUnitsResolver,
      options: ProjectDataResolver,
    },
    children: [
      {
        path: '',
        component: PropertyTenantsListComponent,
        resolve: {
          options: ProjectDataResolver,
          fieldDefs: ProjectsFieldDefsResolver,
        },
        children: [
          {
            path: ':property_unit_id',
            component: PropertyTenantsDetailsComponent,
            resolve: {
              options: ProjectDataResolver,
              fieldDefs: ProjectsFieldDefsResolver,
              propertyUnit: PropertyTenantsPropertyUnitResolver,
              savedViews: SavedViewsResolver,
            },
          },
        ],
      },
    ],
  },
];
